import React, {useEffect} from "react";
import { useState } from "react";
import Web3 from "web3";
import { wearExchangeContractABI, wearExchangeContractAddress, wearNftContractABI } from "../utils/interact";


export default function Card(props) {
  const [nftImage, setNftImage] = useState(null);

  let provider = window.web3.currentProvider;
  const web3 = new Web3(provider);
  
  const wearExchangeContract = new web3.eth.Contract(
    wearExchangeContractABI,
    wearExchangeContractAddress
  )
  
  const wearNFTContract = new web3.eth.Contract(
    wearNftContractABI,
    props.nftCollectionAddress
  )

  const getImage = async () => {
    const nftPrice = await wearExchangeContract.methods.addressPrices(props.nftCollectionAddress, props.imgId).call();
    setNftImage(`${props.nftCollectionAddress}_${web3.utils.fromWei(nftPrice, 'ether')}.jpg`)
  } 

  useEffect(() => {
    getImage()
  }, [])
  

  const exchange = async(owner, id, nftCollectionAddress, event) => {
    event.target.setAttribute('disabled', true);

    const isApproved = await wearNFTContract.methods.isApprovedForAll(owner, wearExchangeContractAddress).call();
    if(!isApproved){
      await wearNFTContract.methods.setApprovalForAll(wearExchangeContractAddress, true).send({from: owner})
      .on('error', function (error) {
        event.target.removeAttribute('disabled');
      })
      .then(async () =>{
        await wearExchangeContract.methods.exchange(nftCollectionAddress, id).send({from: owner})
        .on('error', function (error) {
          event.target.removeAttribute('disabled');
        })
        .then(res => {
          window.location.reload()
        }).catch(error => console.log(error));
      });
    }
    else{
      await wearExchangeContract.methods.exchange(nftCollectionAddress, id).send({from: owner})
      .on('error', function (error) {
        event.target.removeAttribute('disabled');
      })
      .then(res => {
        window.location.reload()
      }).catch(error => console.log(error));
    }    
    console.log('clicked');
  }
 

  if(nftImage !== null){
    return (
      <>
        <div className="card">
          <div className="image">
            <img src={`/stable-nft/nfts/${nftImage}`} alt="" />
          </div>
          <div className="controller">
            <div>
              <h6>Token ID: {props.imgId}</h6>
            </div>
            <button onClick={(e) => exchange(props.walletAccount,props.imgId,props.nftCollectionAddress, e)}>Sell NFT</button>
          </div>
        </div>
      </>
    );
  }else{
    return null
  }
}

